module.exports = __webpack_public_path__ + "img/icon-schedule.7019f442.svg";